import { get, post } from "./base";

const PaymentServ = {
  createOrder: (payload) => post("/payments/create-order", payload),
  verifyPayment: (payload) => post("/payments/verify", payload),
  getHistory: () => get("/payments/history"),
};

export default PaymentServ;
